import SingleUserInfo from './SingleUserInfo';

export default SingleUserInfo;
